<div class="container" id="version-component">
<!--  <h1>{{versionInfo}}</h1>-->

  <div>
    <h2 *ngFor="let e of versionArr">
      {{e}}
    </h2>
  </div>
</div>
